import { combineReducers } from "@reduxjs/toolkit"
import type { RootAppDispatch, RootAppState } from "."
import account from "./account/reducer"
import basket from "./basket/reducer"
import bonus from "./bonus/reducer"
import checkout from "./checkout/reducer"
import checkoutTerms from "./checkout-terms/reducer"
import core from "./core/reducer"
import domainSearch from "./domain-search/reducer"
import marketplace from "./marketplace/reducer"
import messages from "./messages/reducer"
import office from "./office/reducer"
import order from "./order/reducer"
import pMailSearch from "./pmail/reducer"
import quickCheckout from "./quick-checkout/reducer"

export type AppState = RootAppState
export type AppDispatch = RootAppDispatch

const rootReducer = combineReducers({
  account,
  basket,
  checkout,
  quickCheckout,
  bonus,
  marketplace,
  domainSearch,
  pMailSearch,
  office,
  messages,
  core,
  checkoutTerms,
  order,
})

export default rootReducer
